import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { getIdToken } from '../../lib/cognito'
import { useAppSelector } from '../../store'

export function RequireAuth (): JSX.Element | null {
  let location = useLocation()

  let [ isInitialRender, setIsInitialRender ] = useState(true)
  let [ isValidating, setIsValidating ] = useState(false)
  let [ hasAuth, setHasAuth ] = useState(false)

  let profile = useAppSelector(state => state.auth.profile)
  let sub = profile?.sub

  useEffect(() => {
    if (!sub) {
      return
    }

    window.localStorage.setItem('previous-user', sub)
  }, [ sub ])

  useEffect(() => {
    setIsValidating(true)

    getIdToken(false)
      .then(() => {
        setHasAuth(true)
      })
      .catch(() => {
        setHasAuth(false)
      })
      .finally(() => {
        setIsValidating(false)
      })
  }, [ profile ])

  useEffect(() => {
    setIsInitialRender(false)
  }, [])

  if (isInitialRender || isValidating) {
    return null
  }

  if (!hasAuth) {
    let url = new URL('/login', window.location.href)

    if (location.pathname !== '/') {
      url.searchParams.set('redirected-from', location.pathname)
    }

    return (
      <Navigate
        to={[ url.pathname, url.search ].filter(Boolean).join('')}
        replace
      />
    )
  }

  return (
    <Outlet />
  )
}
